import { render, staticRenderFns } from "./OrderMassal-V2.html?vue&type=template&id=692ffa02&"
import script from "./OrderMassal-V2.js?vue&type=script&lang=js&"
export * from "./OrderMassal-V2.js?vue&type=script&lang=js&"
import style0 from "./OrderMassal-V2.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports